<template>
  <el-header class="hearder-container">
    <router-link to="/home/map" class="logo"
      ><img src="../../assets/logo.png" alt="logo"
    /></router-link>
    <span class="user-name">{{ user ? user.userName : "" }}</span>
    <el-dropdown @command="handleCommand">
      <i class="el-icon-setting"></i>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="revise">修改密码</el-dropdown-item>
        <el-dropdown-item command="loginOut">注销</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </el-header>
</template>
<script>
import { mapGetters, mapState } from "vuex";
import Revise from "@/components/Revise";
import eventBus from "@/utils/eventBus.js";
import updatePassWord from "@/api/updatePassWord.js";
export default {
  created() {
    eventBus.$on("password-Change", this.passChange);
  },
  destroyed() {
    eventBus.$off("password-Change", this.passChange);
  },
  data() {
    return {
      form: null,
    };
  },
  computed: {
    // ...mapGetters("loginUser",["status"]),
    ...mapState("loginUser", ["user"]),
  },
  methods: {
    handleCommand(command) {
      if (command === "loginOut") {
        this.loginOut();
      } else if (command === "revise") {
        this.revise();
      }
    },
    async loginOut() {
      await this.$store.dispatch("loginUser/loginOut");
      localStorage.removeItem("userInfo");
      this.$router.push("/login");
    },
    passChange(data) {
      this.form = data;
    },
    revise() {
      const h = this.$createElement;
      this.$confirm("", "修改密码", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        message: h(Revise, {}, []),
        beforeClose: async (action, instance, done) => {
          if (action === "confirm") {
            if (this.form) {
              instance.confirmButtonLoading = true;
              instance.confirmButtonText = "提交中...";
              let res = await updatePassWord({ passWord: this.form.pass });
              if (res === "ok") {
                this.form = null;
                eventBus.$emit("password-Reset");
                setTimeout(() => {
                  done();
                }, 200);
              }
              setTimeout(() => {
                instance.confirmButtonLoading = false;
              }, 300);
            }
          } else {
            eventBus.$emit("password-Reset");
            setTimeout(() => {
              done();
            }, 200);
          }
        },
      })
        .then(() => {
          this.$message({
            showClose: true,
            type: "success",
            message: "修改成功!",
          });
        })
        .catch(() => {});
    },
  },
};
</script>

<style lang="less" scoped>
.hearder-container {
  position: relative;
  background-color: #fff;
  box-shadow: 3px 0 16px rgb(195, 209, 225, 0.1);
  color: #333;
  line-height: 60px;
  text-align: right;
  font-size: 16px;
  width: 100%;
  z-index: 999;

  .user-name {
    margin-right: 10px;
    font-weight: bold;
  }

  .el-icon-setting {
    font-size: 22px;
    background: #316aff;
    color: #fff;
    border-radius: 50%;
    padding: 6px;
  }

  .logo {
    display: inline-block;
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
    height: 50px;

    img {
      height: inherit;
      width: auto;
    }
  }
}
</style>
